import { cn } from "~/core/generic/shadcn-utils";

import OctoTag from "~/components/OctoTag";

import roles from "~/lib/organizations/roles";
import MembershipRole from "~/lib/organizations/types/membership-role";

const RoleBadge: React.FCC<{
  role: MembershipRole;
}> = ({ role }) => {
  const data = roles.find(item => item.value === role);

  return (
    <OctoTag
      className={cn({
        "bg-yellow-lighter text-yellow-dark":
          data?.value === MembershipRole.Owner,
      })}
    >
      {data?.label}
    </OctoTag>
  );
};

export default RoleBadge;
